module.exports = __webpack_public_path__ + "img/user-02.735866d1.jpg";